import { callApiWithData } from './call-api';

export interface RecipeFromImageIngredient {
  name: string;
  quantity: string;
}

export interface RecipeFromImageResult {
  name: string;
  recipe: string;
  ingredients: RecipeFromImageIngredient[];
  preparationTime?: number;
}

export interface SuggestHealthinessResult {
  healthiness: number;
}

export interface SuggestNutritionResult {
  servings: number;
  calories: number;
  protein: number;
  carbs: number;
  fat: number;
}

export const callSuggestHealthinessApi = async (
  name: string,
  description: string,
  ingredientNames: string[]
): Promise<SuggestHealthinessResult> => {
  return await callApiWithData('/meal/suggest-healthiness', { name, description, ingredientNames }, 'POST');
};

export const callSuggestNutritionApi = async (
  name: string,
  description: string,
  ingredientNames: string[],
  servings: number | null
): Promise<SuggestNutritionResult> => {
  return await callApiWithData(
    '/meal/suggest-nutrition',
    { name, description, ingredientNames, ...(servings !== null ? { servings } : {}) },
    'POST'
  );
};

export const callRecipeFromImageApi = async (image: string): Promise<RecipeFromImageResult> => {
  const response = await callApiWithData(
    '/meal/from-image',
    {
      image,
    },
    'POST'
  );

  return {
    name: response.name,
    recipe: response.recipe,
    ingredients: response.ingredients ?? [],
    preparationTime: response.preparationTime,
  };
};
